import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
// import imgLogo from "assets/images/logo.png";
import imgSuccess from "assets/images/success.png";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { SuccessOk } from "configs/statusCode";
// Redux
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/Website/AuthService";
import "./login.scss";
import { API_BASE_URL_ENV } from "helpers/common";
import { toast } from "react-toastify";
import Navbar from "components/Website/Layouts/Navbar";
import Footer from "../../../components/Website/Layouts/Footer";

const apiResetPasswordEndpoint =
	API_BASE_URL_ENV() + "/website/user/forget-password";

const ForgetPassword = (props) => {
	const [codeSent, setCodeSent] = useState(false);
	const [email, setEmail] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleValidSubmit = async (event, values) => {
		setLoading(true);
		try {
			AuthService.forgetPassword(apiResetPasswordEndpoint, values).then(
				(response) => {
					// toast.success(`${response.success} , Please Check Your Email`);
					if (response.success === "Email Sent to your email") {
						setCodeSent(true);
						setLoading(false);
					} else {
						setLoading(false);
					}
				}
			);
			// if (response.success=== "Email Sent to your email") {

			//}
		} catch (error) {
			toast.error(error);
		}
	};
	useEffect(() => {
		setCodeSent(false);
	}, []);
	return (
		<React.Fragment>
			<Navbar />
			<div className="websitPages pt-10rem">
				<MetaTags>
					<title>Reset Password</title>
				</MetaTags>
				<div>
					<Container fluid className='px-lg-5 pb-5 pt-4'>
						<Row className="justify-content-center pb-5 websitPages text-left">
							<Col md={8} lg={7} xl={6} dir="ltr">
								{!codeSent ? (
									<Card className="overflow-hidden br-40 box-shadow mt-5">
										<CardBody className="text-center websitPages">
											{/* <img src={imgLogo} className='mt-3' /> */}
											<Row className="justify-content-center">
												<Col lg={10}>
													<p className="p-0 font-size-32 text-center mt-4 bask-font text-primary fs-italic fw-bold">
														Forgot your password?
													</p>
													{/* <p className="textMuted font-size-13">Use you email address and password to can login</p> */}
													<div className="p-2 pb-3">
														<AvForm
															className="form-horizontal custom-form  formWithLabel"
															onValidSubmit={(e, v) => {
																handleValidSubmit(e, v);
															}}>
															<div className="mb-3 position-relative">
																<label className="text-primary label">
																	Email
																</label>
																<AvField
																	name="email"
																	className="form-control rounded-pill py-3 px-5rem"
																	// placeholder="Enter your Email Address"
																	type="email"
																	value={email}
																	onChange={(e) => {
																		setEmail(e.target.value);
																	}}
																	required
																/>
															</div>

															<div className="mt-4 d-grid">
																<button
																	disabled={loading ? true : false}
																	className="btn btnOrange w-100 btnHeight"
																	type="submit">
																	Send Verification Code
																</button>
															</div>
														</AvForm>
													</div>
												</Col>
											</Row>
										</CardBody>
									</Card>
								) : (
									<Card className="overflow-hidden mt-5 mb-3">
										<CardBody className="text-center">
											<Row className="justify-content-center">
												<Col lg={10}>
													<img src={imgSuccess} className="mt-3 img-fluid" />
													<p className="fw-bold font-size-18 fw-bold pt-3 mb-2">
														Verification Code Send Succseffully{" "}
													</p>
													<p className="textMuted font-size-13">
														We Have Sent an email to <b>{email}</b>
													</p>
													<button
														className="btn btn-success w-100 mt-3"
														onClick={() => {
															props.history.push(`/`);
														}}>
														Done
													</button>
												</Col>
											</Row>
										</CardBody>
									</Card>
								)}
							</Col>
						</Row>
					</Container>
				</div>
				<Footer />
			</div>
		</React.Fragment>
	);
};

export default ForgetPassword;
